export const SET_LOADING = '@productDetails/SET_LOADING';
export const SAVE_DATA = '@productDetails/SAVE_DATA';
export const SET_FILTER = '@productDetails/SET_FILTER';
export const SET_ACTIVE_PAGE = '@productDetails/SET_ACTIVE_PAGE';
export const VM_LOADING = '@productDetails/VM_LOADING';
export const BTN_LOADING = '@productDetails/BTN_LOADING';
export const SET_VM_OPTIONS = '@productDetails/SET_VM_OPTIONS';
export const SET_VM_SELECTED_OPTION = '@productDetails/SET_VM_SELECTED_OPTION';



// WEBPACK FOOTER //
// ./src/Modules/ProductDetails/constants.js